import React from "react";
import { Helmet } from "react-helmet";
import { BsWhatsapp, BsFacebook, BsInstagram, BsEnvelope } from "react-icons/bs";
import logo from "./../../assets/img/landscape.png";
import "./coming-soon.css";

const ComingSoon = () => {
  return (
    <>
      <Helmet>
        <title>Coming Soon | Bansah and Associates</title>
        <meta
          name="description"
          content="Our new website is on its way. Bansah and Associates - Navigating Your Path to Canadian Immigration Success."
        />
      </Helmet>

      <main className="comingSoon">
        <div className="comingSoon__overlay" />

        <div className="comingSoon__content">
          <div className="comingSoon__logo">
            <img src={logo} alt="Bansah and Associates" />
          </div>

          <span className="comingSoon__badge">We're launching soon</span>

          <h1 className="comingSoon__title">
            Something great is <span>on the way</span>
          </h1>

          <p className="comingSoon__subtitle">
            We're putting the finishing touches on our new website. In the
            meantime, our team is ready to help you navigate your path to
            Canadian immigration success.
          </p>

          <div className="comingSoon__actions">
            <a
              href="mailto:info@bansahandassociates.com"
              className="comingSoon__btn comingSoon__btn--primary"
            >
              <BsEnvelope className="comingSoon__btnIcon" />
              Email us
            </a>
            <a
              href="tel:+14167850522"
              className="comingSoon__btn comingSoon__btn--ghost"
            >
              +1 416-785-0522
            </a>
          </div>

          <div className="comingSoon__socials">
            <a
              href="https://wa.me/14167850522"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <BsWhatsapp />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <BsFacebook />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <BsInstagram />
            </a>
          </div>

          <p className="comingSoon__address">
            1111 Albion Rd, Etobicoke, ON M9V 1A9, Canada
          </p>
        </div>
      </main>
    </>
  );
};

export default ComingSoon;
